import React from 'react';
import {StyleSheet, View} from 'react-native';
import CCText from '@/Atoms/CCText';
import CCButton from '@/Atoms/CCButton';
import Box from '@/Atoms/Box';

const styles = StyleSheet.create({
  // Spec §2 card shell: radius 20, soft shadow, no border.
  card: {
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 28,
    alignItems: 'center',
    shadowColor: 'rgba(77,63,55,1)',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 2,
  },
  lockIcon: {
    fontSize: 28,
    marginBottom: 8,
  },
  title: {
    fontSize: 15,
    fontWeight: '600',
    color: '#262322',
    marginBottom: 4,
    textAlign: 'center',
  },
  body: {
    fontSize: 13,
    color: '#888280',
    textAlign: 'center',
    lineHeight: 19,
  },
});

type Props = {
  // The profile owner's display name, for the visitor-copy variant.
  ownerName?: string | null;
  // 'visitor' (default, Milestone 2): a logged-in non-owner viewing
  // Training/Assessment. 'anonymous' (Milestone 4): a logged-out visitor --
  // every one of the 5 tabs uses this variant, since the anonymous payload
  // has no per-tab data at all (only identity + teaser_stats).
  variant?: 'visitor' | 'anonymous';
  onLogin?: () => void;
};

// Visitor-copy variant: no "connect as coach" unlock path exists yet, shown
// in place of Training/Assessment content for any non-owner logged-in
// viewer (Milestone 2). Anonymous variant: shown for all 5 tabs for a
// logged-out visitor (Milestone 4).
export default function LockedTabPanel({
  ownerName,
  variant = 'visitor',
  onLogin,
}: Props) {
  if (variant === 'anonymous') {
    return (
      <Box style={styles.card} testID="locked-tab-panel-anonymous">
        <CCText style={styles.lockIcon}>🔒</CCText>
        <CCText style={styles.title}>Log in to see more</CCText>
        <View>
          <CCText style={styles.body}>
            {ownerName ? `${ownerName}'s` : "This player's"} full stats, games,
            training, and clubs are visible once you log in.
          </CCText>
        </View>
        {onLogin ? (
          <CCButton testID="locked-tab-login" style={{marginTop: 14}} onPress={onLogin}>
            Log in
          </CCButton>
        ) : null}
      </Box>
    );
  }

  return (
    <Box style={styles.card}>
      <CCText style={styles.lockIcon}>🔒</CCText>
      <CCText style={styles.title}>This is private</CCText>
      <View>
        <CCText style={styles.body}>
          {ownerName ? `${ownerName} hasn't` : "This player hasn't"} shared
          this with visitors. Caissa keeps training and assessment details
          between a player and their coach.
        </CCText>
      </View>
    </Box>
  );
}
